import type { JsonRpcRequest, JsonRpcResponse } from "./../../../../../interfaces/index.js";

let rpcId = 0;

export function buildRpcPayload<TParams extends readonly unknown[]>(
  method: string,
  params: TParams
): JsonRpcRequest<TParams> {
  return {
    jsonrpc: "2.0",
    id: ++rpcId,
    method,
    params,
  };
}

export function parseRpcResponse<TResult>(
  json: JsonRpcResponse<TResult>
): TResult {
  if ("error" in json) {
    throw new Error(
      `RPC Error ${json.error.code}: ${json.error.message}`
    );
  }
  return json.result;
}
